var _rect, _rect2, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateLandscape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.53516,
    width: 15.4027,
    height: 29.1629,
    rx: 1.83299,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1631,
    y: 15.2954,
    width: 15.4027,
    height: 29.1629,
    rx: 1.83299,
    transform: "rotate(90 31.1631 15.2954)",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 2,
    width: 12,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5055 8.17599C27.5055 5.83906 25.6064 3.93987 23.2694 3.93987C22.5564 3.93987 21.8786 4.11638 21.2926 4.43408L20.2618 3.4033C21.1302 2.8526 22.161 2.52783 23.2694 2.52783C26.39 2.52783 28.9176 5.05538 28.9176 8.17599H31.0356L28.2116 11.0001L25.3875 8.17599H27.5055Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.8823,
    y: 1.51025,
    width: 8.98157,
    height: 9.97952,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLandscape);
export default __webpack_public_path__ + "static/media/rotate_landscape.793355747690e8c63d94b456bd509652.svg";
export { ForwardRef as ReactComponent };